import { Helmet } from "react-helmet-async";

export default function ExcludedPageHead({ title }: { title: string }) {
  return <Helmet>
    <title>{title} | Splorà Tours</title>
    <meta name="robots" content="noindex, follow" />
    <meta name="description" content={title} />
  </Helmet>;
}